import { render } from "./UserPermissionsView.vue?vue&type=template&id=6e721465"
import script from "./UserPermissionsView.vue?vue&type=script&lang=js"
export * from "./UserPermissionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__